export default Object.freeze({
  Export: 1,
  Import: 2,
});
